module.exports = __webpack_public_path__ + "static/media/custom-ex-6.b7cb371a.jpg";